import { useState } from 'react';
import { addCommasToNumber } from '../../../../Utils/CommonUtils';
import { PlanDropdown } from './components/dropdown';
import { PlanFeatures } from './components/features';
import { ApiPlan } from './types';

export const PlanCard = ({ plan }: { plan: ApiPlan }) => {
  const [isOpen, setIsOpen] = useState(false);
  const icon = plan.iconUrl ? (
    <img src={plan.iconUrl} alt={`${plan.title} icon`} className="w-14 h-14" />
  ) : null;

  return (
    <div className="border  rounded-xxl w-1/3 sm:w-full sm:mb-5">
      <div
        className=" items-center gap-3 w-full justify-between px-6 py-7 rounded-t-xxl"
        style={{
          background:
            'linear-gradient(129deg, rgba(238, 245, 255, 0.40) 31.8%, #EEF5FF 105.92%)',
        }}
      >
        <div className="flex items-center gap-3">
          <div className="w-14 h-14">{icon}</div>
          <div className="text-font-900 font-semibold text-base flex gap-4">
            {plan.title}
            <button
              className="hidden sm:block "
              onClick={() => setIsOpen(!isOpen)}
              aria-expanded={isOpen}
              aria-controls={`details-${plan.id}`}
              aria-label={isOpen ? 'Collapse details' : 'Expand details'}
            >
              <img
                src="https://assets.clear.in/cleartax/images/1747296577_group18142369.svg"
                alt={isOpen ? 'Collapse details' : 'Expand details'}
                className={`w-4 h-4 transition-transform duration-300 ${
                  isOpen ? 'rotate-0' : 'rotate-180'
                }`}
              />
            </button>
          </div>
        </div>
        <div className="flex items-center gap-4 justify-center sm:justify-around">
          <div className="font-bold text-s-24 text-font-900 flex  gap-1 items-center">
            ₹{addCommasToNumber(Math.ceil(Number(plan.basePrice)))}{' '}
            <span className="text-sm font-normal text-s-12 text-grey-500">
              onwards
            </span>
          </div>
          <button
            className="p-2 focus:outline-none px-2 sm:hidden "
            onClick={() => setIsOpen(!isOpen)}
            aria-expanded={isOpen}
            aria-controls={`details-${plan.id}`}
            aria-label={isOpen ? 'Collapse details' : 'Expand details'}
          >
            <img
              src="https://assets.clear.in/cleartax/images/1747296577_group18142369.svg"
              alt={isOpen ? 'Collapse details' : 'Expand details'}
              className={`w-5 h-5 transition-transform duration-300 ${
                isOpen ? 'rotate-0' : 'rotate-180'
              }`}
            />
          </button>
        </div>
      </div>

      {isOpen && plan.incomeBrackets && (
        <PlanDropdown
          incomeBrackets={plan.incomeBrackets}
          discountText={plan.discountText}
          id={`details-${plan.id}`}
        />
      )}

      <hr />

      <PlanFeatures features={plan.features} />
    </div>
  );
};
